import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
    const { user } = useAuth();

    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-ares-void" data-testid="auth-loading">
                <div className="flex flex-col items-center gap-3">
                    <Loader2 className="w-8 h-8 text-ares-orange animate-spin" />
                    <p className="font-mono text-xs uppercase tracking-widest text-ares-muted">Establishing uplink…</p>
                </div>
            </div>
        );
    }

    if (user === false) {
        return <Navigate to="/login" replace />;
    }

    return children;
}
